<template>
    <div class="icon-card">
        <div class="icon-card__inner">
            <div class="icon-card__cover">
                <img class="icon-card__img" :src="image" :alt="title">
            </div>
            <div class="icon-card__body">
                <div class="icon-card__main">
                    <div class="icon-card__title" v-html="title"></div>
                </div>
                <div class="icon-card__text" v-if="text">{{ text }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconCard',
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
    },
    setup: (props, ctx) => {
        return {

        }
    },
}
</script>

<style lang="scss" scoped>
    .icon-card {
        &__cover {
            display: block;
            line-height: 1px;
            border-radius: var(--br-1);
            overflow: hidden;
            width: 50px;
            height: 50px;
            min-height: 50px;

            img {
                object-fit: cover;
                width: 100%;
                transition: all .3s ease 0s;
            }
        }
        &__inner {
            border-radius: var(--br-1);
            overflow: hidden;
            transition: all .3s ease 0s;
            display: flex;
            flex-direction: column;
            height: 100%;

            @include tablet {
                padding: 20px 0;
            }
            @include mobile {
                padding: 16px 0px;
            }

            &:hover {
                text-decoration: none;
            }
        }
        &__body {
            margin-top: 24px;
            display: flex;
            flex-direction: column;
            height: 100%;

            @include tablet {
                max-width: 320px;
            }

            @include mobile {
                margin-top: 16px;
            }
        }
        &__title {
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: var(--c-gray-100);
            transition: all .3s ease;
        }
        &__text {
            margin-top: 22px;
            font-size: 14px;
            line-height: 20px;
            color: var(--c-gray-100);

            @include tablet {
                margin-top: 16px;
            }

            @include mobile {
                font-size: 12px;
                line-height: 16px;
                margin-top: 4px;
            }
        }
    }
</style>